import { createAsyncAction } from '../../utils/asyncHelpers';
import * as actionTypes from '../../constants/actionTypes/reportGridActionTypes';
import { reportGridItemsFetch } from '../actionHelpers/endpoints';

export const fetchReportGridItems = createAsyncAction(
  actionTypes.REPORT_GRID_ITEMS_FETCH,
  reportGridItemsFetch
);
